<template>
    <div class="user">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>服务商管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>服务商列表</h2>
                <div class="item" @click="add" v-if="role_id!=4||(role_id==4&&hasCreat)"><i class="icon el-icon-circle-plus-outline" type="primary"></i>新增服务商</div>
                <div class="item" @click="addType" v-if="role_id==1"><i class="icon el-icon-circle-plus-outline" type="primary"></i>新增服务商类型</div>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-form :inline="true" align="left" class="demo-form-inline">
                    <el-form-item label="城市名称" v-if="role_id==1">
                        <el-select v-model="form.city_id" clearable  @clear="getServiceList()" filterable placeholder="输入城市关键字"  style="width: 150px;">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务商名称">
                        <el-input v-model="form.name" placeholder="服务商名称" clearable @clear="getServiceList()"></el-input>
                    </el-form-item>
                    <el-form-item label="服务商主营业务">
                        <el-cascader
                            v-model="form.cate_id"
                            :options="typeList"
                            :props="{label:'cate_name',value:'cate_id',children:'child',checkStrictly: true}"
                            :clearable="true"
                            @clear="getServiceList()"
                            @change="handleChange">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="状态" >
                        <el-select v-model="form.status" clearable @clear="getServiceList()" placeholder="请选择状态" style="width: 150px;">
                            <el-option label="已拒绝" value="-1"></el-option>
                            <el-option label="通过" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="name" label="服务商名称" align="center"/>
                    <el-table-column prop="city" label="所属城市" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.big_city_name}} {{scope.row.city}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="big_cate_name" label="服务商类型" align="center"/>
                    <el-table-column prop="cate_name" label="主营业务" align="center"/>
                    <el-table-column prop="big_cate_name" label="价格" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.price_des_img|handleImg" alt="" style="width: 50px;height: 50px;">
                        </template>
                    </el-table-column>
                    <el-table-column prop="contact_name" label="联系人姓名" align="center"/>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.status>0?'已审':'未审'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="city" label="所属城市" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.big_city_name}} {{scope.row.city}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="area" label="是否显示" align="center">
                        <template slot-scope="scope">
                            <el-switch  v-model="scope.row.is_show==1?true:false" @change="changeStatus(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="area" label="是否置顶" align="center">
                        <template slot-scope="scope">
                            <el-switch  v-model="scope.row.is_hot==1?true:false" @change="changeHot(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="area" label="排序" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sort" placeholder="序号" @change="updateSort(scope.row)"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center" width="180px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="detail(scope.row)">查看详情</el-button>
                            <el-button v-if="scope.row.status==-1&&(role_id!=4||(role_id==4&&hasCheck))" type="text" size="small" @click="pass(scope.row)">通过</el-button>
                            <el-button v-if="scope.row.status==-1&&(role_id!=4||(role_id==4&&hasCheck))" type="text" size="small" @click="refuse(scope.row)">拒绝</el-button>
                            <el-button v-if="role_id!=4||(role_id==4&&hasUpdate)" type="text" size="small"  @click="updateRow(scope.row)">修改</el-button>
                            <el-button v-if="role_id!=4||(role_id==4&&hasDel)" type="text" size="small" @click="deleRow(scope.row)">删除</el-button>
                            <el-button v-if="role_id!=4||(role_id==4&&hasDel)" type="text" size="small" @click="caseList(scope.row)">案例</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pages"
                        :current-page="page"
                        :page-size="20"
                        @current-change="handleCurrentChange"
                        style="margin-top: 20px; text-align: right;"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog
                title="服务商详情"
                :visible.sync="infoPop"
                width="500px"
        >
            <div class="info-box" style="text-align: left">
                <p class="item"><span class="info-tit">服务商名称：</span><span class="val">{{infoData.name}}</span></p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">服务商类别：</span><span class="val">{{infoData.big_cate_name}}</span></p>
                    <p><span class="info-tit">服务商小类：</span><span class="val">{{infoData.cate_name}}</span></p>
                </div>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">所属城市：</span><span class="val">{{infoData.big_city_name}}{{infoData.city}}</span></p>
                    <p><span class="info-tit">所属区域：</span><span class="val">{{infoData.address}}</span></p>
                </div>
                <p class="item"><span class="info-tit">详细地址：</span><span class="val">{{infoData.address}}</span></p>
                <div class="item d_flex j_b">
                    <p><span class="info-tit">管理员：</span><span class="val">{{infoData.contact_name}}</span></p>
                    <p><span class="info-tit">管理员职务：</span><span class="val">{{infoData.contact_phone}}</span></p>
                </div>
                <div class="item d_flex j_b"v-if="role_id!=4||(role_id==4&&hasSee)">
                    <p><span class="info-tit">管理员微信：</span><span class="val">{{infoData.contact_wx}}</span></p>
                    <p><span class="info-tit">管理员电话：</span><span class="val">{{infoData.contact_position}}</span></p>
                </div>
                <div class="site-img-box">
                    <p>价格介绍图</p>
                    <div class="swiper" v-if="infoData.price_des_img">
                        <mu-carousel>
                            <mu-carousel-item v-for="(item,i) in infoData.price_des_img.split(',')" :key="i">
                                <img :src="item|handleImg" @click="previewIMg(item)">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                    <p>产品介绍图</p>
                    <div class="swiper"  v-if="infoData.cover">
                        <mu-carousel>
                            <mu-carousel-item v-for="(item,i) in infoData.cover.split(',')" :key="i">
                                <img :src="item|handleImg" @click="previewIMg(item)">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="infoPop = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="拒绝原因"
                :visible.sync="refusePop"
                width="500px"
                style="text-align: left"
        >
            <div class="pop-box">
                <el-input type="textarea" v-model="remark" maxlength="100" placeholder="请输入拒绝原因" style="margin-bottom:20px ;"></el-input>
                <div class="btn-box">
                    <el-button type="primary" @click="subRefuse">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
                :visible.sync="imgPop"
                width="800px"
                style="text-align: center;"
        >
            <img :src="preImg" alt="" style="width: 100%;">
        </el-dialog>
    </div>
</template>

<script>
    import {getServiceList,serviceTypeList,delService,setStatus,updateService} from '../../api/service'
    import {searchCity} from '../../api/city'
    import { mapState } from 'vuex';
    import {updateSiteCase} from "../../api/site";
    export default {
        name: "service",
        data() {
            return {
                tableData: [],
                cityList:[],
                typeList:[],
                pages:1,
                page:1,
                form:{
                    city_id:'',
                    status:'',
                    cate_name:'',
                    cate_ids:'',
                    cate_id:[],
                },
                infoPop:false,
                refusePop:false,
                infoData:{},
                remark:'',
                refuseData:'',
                loading:true,
                role_id:0,
                role_ads:[],
                hasCreat:false,
                hasDel:false,
                hasUpdate:false,
                hasCheck:false,
                hasSee:false,
                preImg:'',
                imgPop:false,
            }
        },
        mounted(){
            this.role_id=localStorage.getItem('ROLE');
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            this.role_ads=JSON.parse(localStorage.getItem('USERINFO')).role_adm_access_ids;
            console.log(this.role_ads);
            if(this.role_ads&&this.role_ads.length>0){
                this.hasCreat= this.role_ads.includes('23');
                this.hasUpdate= this.role_ads.includes('24');
                this.hasDel= this.role_ads.includes('25');
                this.hasCheck= this.role_ads.includes('26');
                this.hasSee= this.role_ads.includes('27');
            }
            this.getServiceList();
            this.searchCity();
            this.serviceTypeList();
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        methods:{
            info(){

            },
            add(){
                this.$router.push({path: '/service/add'});
            },
            onSubmit(){
                this.getServiceList();
            },
           getServiceList(){
                this.loading=true;
                console.log(this.form);
                if(this.form.cate_id){
                    this.form.cate_id=this.form.cate_id[1]?this.form.cate_id[1]:this.form.cate_id[0];
                }else{
                    this.form.cate_id='';
                }
                this.form.p=this.page;
                getServiceList(this.form).then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.pages=res.data.total_num;
                        console.log(res.data);
                    }
                })
            },
            searchCity(){
                searchCity({level:2}).then(res=>{
                    if(res.code==1){
                        this.cityList=res.data;
                    }
                })
            },
            serviceTypeList(){
                serviceTypeList().then(res=>{
                    if(res.code==1){
                        this.typeList=res.data;
                        console.log(res.data);
                    }
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getServiceList()
            },
            detail(row){
                this.infoPop=true;
                this.infoData=row;
            },
            deleRow(row){
                this.$confirm('此操作将永久删除该服务商, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delService({sid:row.sid}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getServiceList();
                        }
                    })
                })
            },
            updateRow(row){
                localStorage.setItem('update_service',JSON.stringify(row))
                this.$router.push({path: '/service/add?type=1'});
            },
            pass(row){
                setStatus({
                    sid:row.sid,
                    status:1
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.getServiceList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            refuse(row){
                this.refusePop=true;
                this.refuseData=row;
            },
            subRefuse(){
                if(!this.remark){
                    this.$message.error('请输入拒绝原因')
                    return;
                }
                setStatus({
                    sid:this.refuseData.sid,
                    status:8,
                    remark:this.remark
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.getServiceList();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            addType(){
                this.$router.push({path: '/service/type'});
            },
            handleChange(value) {
                if(value&&value.length>0){
                    this.form.cate_id=value.map(val=>{
                        return val;
                    })
                }
            },
            caseList(row){
                this.$router.push({path:'/service/case',query:{id:row.sid,name:row.name}})
            },
            previewIMg(img){
                this.imgPop=true;
                if(img&&img.indexOf('http')!=-1){
                    this.preImg=img;
                }else{
                    this.preImg=this.baseUrl+img;
                }
            },
            changeStatus(row){
                updateService({
                    sid:row.sid,
                    is_show:row.is_show==1?2:1,
                    is_hot:row.is_hot?1:0,
                    sort:row.sort,
                }).then(res=>{
                    if(res.code==1){
                        this.getServiceList();
                        this.$message.success('修改成功');
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            changeHot(row){
                updateService({
                    sid:row.sid,
                    is_hot:row.is_hot?0:1,
                    is_show:row.is_show==1?1:2,
                    sort:row.sort,
                }).then(res=>{
                    if(res.code==1){
                        this.getServiceList();
                        this.$message.success('修改成功');
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            updateSort(row){
                updateService({
                    sid:row.sid,
                    is_hot:row.is_hot?1:0,
                    is_show:row.is_show==1?1:2,
                    sort:row.sort,
                }).then(res=>{
                    if(res.code==1){
                        this.getServiceList();
                        this.$message.success('修改成功');
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-content{
        padding: 20px;
        .table{
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 4px 4px 0 #e1e5eb;
        }
    }
    .info-box{
        .item{
            padding: 10px 0;
            .info-tit{
                font-size: 15px;
                color: #999999;
            }
            .val{
                color: #ff6b11;
            }
        }
        .site-img-box{
            p{
                font-size: 18px;
                color: #333333;
                font-weight: bold;
                margin-top: 20px;
                margin-bottom: 20px;
            }
            .mu-carousel{
                width: 100%;
                height: 300px;
            }
        }
    }
</style>

